export default "__VITE_ASSET__BcrGU2$X__"